import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone';
import { AiOutlineUpload } from 'react-icons/ai';
import { useStore } from '../../../Stores/store';

export default function DocumentUploadWidget(){
    const { managementStore } = useStore();
    const { setDocumentToUpload } = managementStore;

    const dzBase = "flex flex-col items-center justify-center gap-2 border-2 border-dashed border-gray-300 rounded-md h-28 w-4/5 mx-auto cursor-pointer transition-colors hover:border-gray-500";
    const dzActive = "flex flex-col items-center justify-center gap-2 border-2 border-dashed border-green-400 rounded-md h-28 w-4/5 mx-auto cursor-pointer";

    const onDrop = useCallback((acceptedFiles : File[]) => {
        if(acceptedFiles && acceptedFiles.length > 0){
            setDocumentToUpload(acceptedFiles[0].name, acceptedFiles[0]);
        }
    }, [setDocumentToUpload]);

    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

    return (
    <div {...getRootProps()} className={isDragActive ? dzActive : dzBase}>
        <input {...getInputProps()} />
        <AiOutlineUpload className="text-3xl text-gray-500" />
        <h4 className="text-sm m-0">Upload New Document</h4>
    </div>
    );
}
